import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { useContextualHelp } from 'contexts/ContextualHelpContext';

export default function ContextualHelpIcon({ contextKey, size = 'small' }) {
  const { hasContext, ask } = useContextualHelp();

  if (!hasContext(contextKey)) return null;

  const handleClick = (event) => {
    event.stopPropagation();
    void ask.forContext(contextKey);
  };

  return (
    <Tooltip title={ask.tooltipLabel}>
      <IconButton
        component="span"
        role="button"
        tabIndex={0}
        size={size}
        aria-label={ask.tooltipLabel}
        onClick={handleClick}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            event.stopPropagation();
            handleClick(event);
          }
        }}
        sx={{ ml: 0.5, color: 'text.secondary', display: 'inline-flex', verticalAlign: 'middle' }}
      >
        <QuestionCircleOutlined />
      </IconButton>
    </Tooltip>
  );
}

ContextualHelpIcon.propTypes = {
  contextKey: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large'])
};
